import script from "./Subscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./Subscriptions.vue?vue&type=script&setup=true&lang=js"

import "./Subscriptions.vue?vue&type=style&index=0&id=bc4254b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc4254b4"]])

export default __exports__